const { detectIncognito } = require('detectincognitojs');
const http = require('../lib/httpClient');
const { getChannelId, getXCommerceValue } = require('../lib/browserData');
const { setItemInSessionStorage } = require('../lib/browserData');
const { getEcommId } = require('../lib/browserData');
const { decodeJWT } = require('../utils/decoder');
const satelliteTrack = require('../utils/toTrack');
const catalystGetPublicKey = require('./catalystGetPublicKey');
const { encrypt } = require('../utils/encryption');
const { COMMERCE_HEADER, SESSION_STORAGE } = require('../constants');

const catalystLoginError = {
  code: 'CATALYST_LOGIN_ERROR',
  message: 'Unable to login',
};

const loginEndpoint = '/s/auth/v1/login';
const loginByOTPEndpoint = '/s/auth/v1/otp-login';

async function getEncryptedPassword(tenantId, catalystBaseUrl, password) {
  const defaultResponse = {
    encryptedPassword: password,
    encryptionHeaders: { 'x-encrypted': false },
  };
  const publicKey = await catalystGetPublicKey(tenantId, catalystBaseUrl);
  if (!publicKey) return defaultResponse;
  const encryptedPassword = encrypt(publicKey, password);
  return { encryptedPassword, encryptionHeaders: { 'x-encrypted': true } };
}

async function getdeviceData() {
  let incognito;

  try {
    const incognitoResponse = await detectIncognito();
    incognito = incognitoResponse.isPrivate;
  } catch {
    incognito = null;
  }
  return {
    browserDetails: {
      cookie: navigator.cookieEnabled,
      incognito,
    },
  };
}

async function catalystLogin(
  email,
  password,
  tenantId,
  catalystBaseUrl = '',
  isOTPLogin = false,
  otpType = 'email',
  additionalHeaders = {},
  additionalInfo = {},
) {
  const url = `${catalystBaseUrl}${isOTPLogin ? loginByOTPEndpoint : loginEndpoint}`;
  const { encryptedPassword, encryptionHeaders } = !isOTPLogin
    ? await getEncryptedPassword(tenantId, catalystBaseUrl, password)
    : {};

  const reqBody = {
    emailAddress: email,
    ...(isOTPLogin ? { otp: password } : { password: encryptedPassword }),
    ...(isOTPLogin ? { otpType } : {}),
    ...(!isOTPLogin && { deviceData: await getdeviceData() }),
  };
  const result = await http.post(url, reqBody, {
    headers: {
      ...additionalHeaders,
      'x-channel-id': getChannelId(),
      'x-ecomm-name': getEcommId(tenantId, additionalInfo),
      ...(!isOTPLogin ? encryptionHeaders : {}),
      'x-commerce': getXCommerceValue(catalystBaseUrl) || COMMERCE_HEADER,
    },
  });

  const { responseBody, response } = result || {};

  if (!responseBody) return { data: undefined, errors: [catalystLoginError] };
  setItemInSessionStorage(SESSION_STORAGE.USER_DATA, responseBody);

  const { idToken: sessionJWT, errors } = responseBody;
  if (errors) return { data: undefined, errors };

  const sessionData = decodeJWT(sessionJWT);
  const { session: { status: sessionStatus } = {} } = sessionData;
  const allowedStatus = ['Authenticated'];

  if (!allowedStatus.includes(sessionStatus)) {
    return {
      data: undefined,
      errors: [
        {
          code: 'LOGIN_ERROR_NON_HARD_LOGIN',
          message: 'User not hard logged in',
        },
      ],
    };
  }
  if (isOTPLogin) {
    satelliteTrack('pwrdreset_success');
  }
  return { data: { ...responseBody, ...sessionData }, errors: [], response };
}

module.exports = catalystLogin;
